// SettingsNavigationBar.tsx
import React, { useState, MouseEvent, useEffect } from "react";
import { IconButton, Menu, MenuItem, Tooltip, FormControl, Typography,Divider,Grid } from "@mui/material";
import BusinessIcon from '@mui/icons-material/Business';
import { useNavigation, useAuth, useLoading } from "../Context/Contexts";
import {
    CompanyAutoComplete
} from "./AutoComplete/AutoCompletes";
import { useTranslation } from "react-i18next";

const CompanyNavigationBar: React.FC = () => {
    const {  authService,} = useAuth();
    const { navigate } = useNavigation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const { showLoading, hideLoading } = useLoading();
    const [showCompanySelector, setShowCompanySelector] = useState(false);
    const [company, setCompany] = useState("");
    const handleClick = (event: MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget);
    const handleClose = () => { setAnchorEl(null); setShowCompanySelector(false); };
    const { t } = useTranslation();
    const handleNavigate = (to: string) => {
        navigate({ path: to });
        handleClose();
    };

    const handleShowCompanySelector = async (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        var show = !showCompanySelector;
        if (!show) {
            setShowCompanySelector(show);
            return;
        }
        try {

            var response = await authService.get<string>("/userSettingsApi/GetSessionValue?key=Unit");
            if (response) setCompany(String(response));
            setShowCompanySelector(show);
       
        } catch (error) {
            console.error("Failed to update session value:", error);
        }
    }
    const handleCompanyChange = async (selected: { value: string } | null) => {
        if (!selected) return;
        if (selected.value === company) return;
        showLoading();
        try {
            await authService.post("/userSettingsApi/SetSessionValue",
                {
                    key: "Unit",
                    stringValue: selected.value,
                }
            );

        } catch (error) {
            console.error("Failed to update session value:", error);
        }
        finally {
            hideLoading();
            window.location.reload();
        }
    };


    return (
        <>
            <Tooltip title={t("common.company")}>
            <IconButton onClick={handleShowCompanySelector} color="secondary">
                    <BusinessIcon />
                </IconButton>
            </Tooltip>

            {/* Dropdown shown when button is clicked */}
           
                <Menu anchorEl={anchorEl} open={showCompanySelector} onClose={handleClose} >

                <Grid container>
                    {showCompanySelector && (
                        <Grid item xs={12} sm={6} md="auto">
                            <FormControl
                                sx={{
                                    borderRadius: 2,
                                    width: {
                                        xs: "80vw", // full width on mobile
                                        sm: "40vw", // medium on tablets
                                        md: "12vw"  // small on large screens
                                    }
                                }}
                            >
                                <CompanyAutoComplete
                                    valueId={company}
                                    onChange={handleCompanyChange}
                                    sx={{
                                        borderRadius: 2,
                                        width: "90%",
                                        ml: "0.5em"
                                    }}
                                />
                            </FormControl>
                        </Grid>
                    )}
                </Grid>
                </Menu>
   
           
        </>
    );
};

export default CompanyNavigationBar;
